import React from 'react';
import styled, { keyframes } from 'styled-components';
import { MultipleSelectAtomic } from '@synergy/atomics_and_hooks';
import Theme from '../../../styles/Theme/Theme';
import { FilterSwitch } from '../Atomics/FilterSwitch';

const slideDown = keyframes`
    from {
        opacity: 0;
        max-height: 0;
        margin-bottom: 0;
        padding-bottom: 0;
        transform: translateY(-10px);
        overflow: hidden;
    }
    99% {
        overflow: hidden;
    }
    to {
        opacity: 1;
        max-height: 500px;
        transform: translateY(0);
        overflow: visible;
    }
`;

const slideUp = keyframes`
    from {
        opacity: 1;
        max-height: 500px;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        max-height: 0;
        margin-bottom: 0;
        padding-bottom: 0;
        transform: translateY(-10px);
    }
`;

const SectionWrapper = styled.div`
    margin-bottom: ${Theme.spacing['s03']};
    padding-bottom: ${Theme.spacing['s05']};
    border-bottom: 1px solid #C2C2C2;
    animation: ${slideDown} 0.3s ease-out forwards;

    &.closing {
        animation: ${slideUp} 0.3s ease-out forwards;
        overflow: hidden;
    }

    .ant-select .ant-select-selector {
        border: 1px solid #C2C2C2 !important;
        border-radius: 8px !important;
        background-color: #fff !important;
        color: ${Theme.color['coolgray-12']} !important;
    }

    .ant-select .ant-select-selection-placeholder {
        color: ${Theme.color['coolgray-8']} !important;
    }

    .ant-select .ant-select-arrow {
        color: ${Theme.color['coolgray-8']};
    }

    .dropdown-spacer {
        margin-top: 12px;
    }
`;

/**
 * FilterExpandedSection - The collapsible content area under a FilterCheckboxItem.
 * Renders one or more MultipleSelectAtomic dropdowns and an optional switch.
 *
 * @param {Array}    dropdowns   - Array of dropdown configs:
 *   {
 *     optionsData,        // options array for MultipleSelectAtomic
 *     handleChange,       // (placeholder, values) => void
 *     defaultValue,       // currently selected values
 *     placeholder,        // string placeholder
 *   }
 * @param {Object}   switchProps - Optional. If provided renders a FilterSwitch:
 *   { checked, onChange, label, tooltip }
 * @param {string}   className - Optional. Additional CSS class
 */
export const FilterExpandedSection = ({ dropdowns = [], switchProps, className = '' }) => {
    return (
        <SectionWrapper className={className}>
            {dropdowns.map((dropdown, i) => (
                <div key={i} className={i > 0 ? 'dropdown-spacer' : ''}>
                    <MultipleSelectAtomic
                        optionsData={dropdown.optionsData}
                        handleOptionsChange={(placeholder, values) => {
                            if (values) dropdown.handleChange(values);
                        }}
                        defaultValue={dropdown.defaultValue || []}
                        fullWidth={true}
                        placeholder={dropdown.placeholder}
                        allAvailable={true}
                        noTags={true}
                    />
                </div>
            ))}

            {switchProps && (
                <FilterSwitch
                    checked={switchProps.checked}
                    onChange={switchProps.onChange}
                    label={switchProps.label}
                    tooltip={switchProps.tooltip}
                />
            )}
        </SectionWrapper>
    );
};
